import {
    get_all_templates,
    get_templates_by_client,
    create_template,
    update_template,
    delete_template,
    add_criterion_to_template,
    remove_criterion_from_template
} from "../Services/template.service";
import { TemplateActionTypes } from "./actionTypes";
import { message } from "antd";
import i18n from "../i18n"; // ✅ ajout multilingue

// Récupération des templates accessibles par l'utilisateur
export function RequestFetchTemplates() {
    return async dispatch => {
        try {
            const result = await get_all_templates();
            dispatch(setTemplates(result.data));
        } catch (error) {
            dispatch(setTemplateError(
                error.response?.data?.error ||
                error.response?.data?.message ||
                error.response?.data?.detail ||
                i18n.t("criteriaView:template.messages.loadError")
            ));
        }
    };
}

// Récupération des templates d'un client
export function RequestFetchTemplatesByClient(clientId) {
    return async dispatch => {
        try {
            const result = await get_templates_by_client(clientId);
            dispatch(setTemplates(result.data));
        } catch (error) {
            dispatch(setTemplateError(
                error.response?.data?.error ||
                error.response?.data?.message ||
                error.response?.data?.detail ||
                i18n.t("criteriaView:template.messages.loadClientError")
            ));
        }
    };
}

// Création d'un template
export function RequestCreateTemplate(payload) {
    return async (dispatch, getState) => {
        try {
            const { templates } = getState().template;
            if (templates.some(t => t.title === payload.title)) {
                dispatch(setTemplateError(i18n.t("criteriaView:template.messages.duplicate")));
                throw new Error("Duplicate template.");
            }

            const result = await create_template(payload);
            dispatch(addTemplate(result.data));
            message.success(result.message || i18n.t("criteriaView:template.messages.created"));
            return result.data;
        } catch (error) {
            dispatch(setTemplateError(
                error.response?.data?.error ||
                error.response?.data?.message ||
                error.response?.data?.detail ||
                error.message ||
                i18n.t("criteriaView:template.messages.server")
            ));
        }
    };
}

// ✏️ Mise à jour d’un template
export function RequestUpdateTemplate(id, payload) {
    return async dispatch => {
        try {
            const result = await update_template(id, payload);
            dispatch(editTemplate(result.data.id, result.data.title));
            message.success(result.message || i18n.t("criteriaView:template.messages.updated"));
        } catch (error) {
            dispatch(setTemplateError(
                error.response?.data?.error ||
                error.response?.data?.message ||
                error.response?.data?.detail ||
                i18n.t("criteriaView:template.messages.server")
            ));
        }
    };
}

// 🗑 Suppression d’un template
export function RequestDeleteTemplate(id) {
    return async dispatch => {
        try {
            const res = await delete_template(id);
            dispatch(deleteTemplate(id));
            message.success(res.message || i18n.t("criteriaView:template.messages.deleted"));
        } catch (error) {
            dispatch(setTemplateError(
                error.response?.data?.error ||
                error.response?.data?.message ||
                error.response?.data?.detail ||
                i18n.t("criteriaView:template.messages.server")
            ));
        }
    };
}

// Ajout d’un critère à un template
export function RequestAddCriterion(templateId, criterionId) {
    return async dispatch => {
        try {
            const result = await add_criterion_to_template(templateId, criterionId);
            if (result.success) {
                message.success(result.message || i18n.t("criteriaView:template.messages.addCriterion"));
                return result.data;
            }
        } catch (error) {
            dispatch(setTemplateError(
                error.response?.data?.error ||
                error.response?.data?.message ||
                error.response?.data?.detail ||
                i18n.t("criteriaView:template.messages.server")
            ));
        }
    };
}

// Suppression d’un critère d’un template
export function RequestRemoveCriterion(templateId, criterionId) {
    return async dispatch => {
        try {
            const result = await remove_criterion_from_template(templateId, criterionId);
            dispatch({
                type: TemplateActionTypes.UPDATE_TEMPLATE,
                payload: {
                    id: result.data.id,
                    criteria: result.data.criteria,
                    title: result.data.title
                }
            });
            message.success(result.message || i18n.t("criteriaView:template.messages.removeCriterion"));
            return result.data;
        } catch (error) {
            dispatch(setTemplateError(
                error.response?.data?.error ||
                error.response?.data?.message ||
                error.response?.data?.detail ||
                i18n.t("criteriaView:template.messages.server")
            ));
            throw error;
        }
    };
}

// Actions Redux
export const setTemplates = (templates) => ({
    type: TemplateActionTypes.SET_TEMPLATES,
    payload: templates,
});

export const addTemplate = (template) => ({
    type: TemplateActionTypes.ADD_TEMPLATE,
    payload: {
        ...template,
        criteria: template.criteria || []
    },
});

export const deleteTemplate = (templateId) => ({
    type: TemplateActionTypes.DELETE_TEMPLATE,
    payload: templateId,
});

export const editTemplate = (id, title) => ({
    type: TemplateActionTypes.EDIT_TEMPLATE,
    payload: { id, title },
});

export const setEditingTemplate = (template) => ({
    type: TemplateActionTypes.SET_EDITING_TEMPLATE,
    payload: template,
});

export const setSelectedTemplate = (templateId) => ({
    type: TemplateActionTypes.SET_SELECTED_TEMPLATE,
    payload: templateId,
});

export const setFilters = (filters) => ({
    type: TemplateActionTypes.SET_FILTERS,
    payload: filters,
});

export const setSearchTerm = (term) => ({
    type: TemplateActionTypes.SET_SEARCH_TERM,
    payload: term,
});

export const setPage = (page) => ({
    type: TemplateActionTypes.SET_PAGE,
    payload: page,
});

export const setActiveTab = (tab) => ({
    type: TemplateActionTypes.SET_ACTIVE_TAB,
    payload: tab,
});

export const setNewTemplateName = (name) => ({
    type: TemplateActionTypes.SET_NEW_TEMPLATE_NAME,
    payload: name,
});

export const setTemplateError = (errorMessage) => ({
    type: TemplateActionTypes.SET_ERROR,
    payload: errorMessage,
});
